// firebase/compat keeps the v8 namespaced API (firebase.auth(), auth().signIn…,
// firebase.auth.EmailAuthProvider) while running on the current SDK, so no call
// site changes. Migrate to the modular API incrementally later if we want tree-shaking.
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import firebaseConfig from '@/firebaseConfig.js'

const firebaseApp = firebase.initializeApp(firebaseConfig)
var db = firebaseApp.firestore()
var auth = firebaseApp.auth()

export default {
  db: db,
  auth: auth,
  firebase: firebase,
  EmailAuthProvider: firebase.auth.EmailAuthProvider
}
